import { Segment } from 'types';

export type BreedIndexRule = {
  name: string;
  valueType: string;
};

export type BreedIndexRuleConfig = {
  segment: Segment;
  indices: BreedIndexRule[];
};

const ZC_INDICES: BreedIndexRule[] = [
  { name: 'iABCZ', valueType: 'DEP' },
  { name: 'IQG', valueType: 'DEP' },
  { name: 'MGTe', valueType: 'DEP' },
];

const EC_MAIN_INDICES: BreedIndexRule[] = [
  { name: 'Ind. DESM', valueType: 'TOP%' },
  { name: 'Ind. FINAL', valueType: 'TOP%' },
  { name: 'IND CARC', valueType: 'TOP%' },
  { name: 'IBC', valueType: 'TOP%' },
  { name: 'PD', valueType: 'TOP%' },
  { name: 'PA', valueType: 'TOP%' },
  //{ name: 'GND', valueType: 'TOP%' },
  { name: 'Ind.DESM', valueType: 'TOP%' },
  { name: 'Ind.FINAL', valueType: 'TOP%' },
];

const EC_IQG_INDICES: BreedIndexRule[] = [
  { name: 'IQG', valueType: 'TOP%' },
];

// Breed-specific allowlist for which indices appear in bull cards and filters.
// Add or remove entries here when a client asks to change index visibility.
export const breedIndexRules: Record<string, BreedIndexRuleConfig> = {
  // Corte Zebu
  'nelore mocho': { segment: 'zc', indices: ZC_INDICES },
  'nelore ceip': { segment: 'zc', indices: ZC_INDICES },
  'nelore po': { segment: 'zc', indices: ZC_INDICES },

  // Corte Taurino
  'aberdeen angus': { segment: 'ec', indices: EC_MAIN_INDICES },
  'brangus': { segment: 'ec', indices: EC_MAIN_INDICES },
  'braford': { segment: 'ec', indices: EC_MAIN_INDICES },
  'hereford mocho': { segment: 'ec', indices: EC_MAIN_INDICES },
  'santa gertrudis': { segment: 'ec', indices: EC_IQG_INDICES },
  'senepol': { segment: 'ec', indices: EC_IQG_INDICES },
};

export default breedIndexRules;
